import {
  PublicClientApplication,
  type Configuration,
  type PublicClientApplication as IPublicClientApplication,
} from "@azure/msal-browser";

// Singleton instance
let msalInstance: IPublicClientApplication | null = null;
let msalInitialized = false;

export function getSSOConfig() {
  return {
    clientId: process.env.VUE_AZURE_CLIENT_ID || "1194105d-697c-457c-bc6b-1d839a77d3f8",
    authority: process.env.VUE_AZURE_AUTHORITY || 
      "https://login.microsoftonline.com/organizations",
    redirectUri: `${window.location.origin}/auth/callback`,
  };
}

export async function getMsalInstance(): Promise<IPublicClientApplication> {
  if (msalInstance && msalInitialized) {
    return msalInstance;
  }

  const ssoConfig = getSSOConfig();
  
  const config: Configuration = {
    auth: {
      clientId: ssoConfig.clientId,
      authority: ssoConfig.authority,
      redirectUri: ssoConfig.redirectUri,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };

  msalInstance = new PublicClientApplication(config);
  await msalInstance.initialize();
  msalInitialized = true;

  return msalInstance;
}

